// generated by genversion
const version = '6.12.0';

export { version };
//# sourceMappingURL=version.mjs.map
